import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
    Button,
    Grid,
    Typography,
    Paper,
    Checkbox,
    FormControlLabel,
    FormLabel,
    FormHelperText,
    TableCell,
    TableRow,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    InputAdornment,
    InputLabel,
    ButtonGroup
} from '@material-ui/core';
import {
    getCheckInTCards_GetByRegNumber,
    getTCards_GetCustomerContacts,
    getTCards_GetExistingTCards,
    getTCards_GetPartReqsByHeaderRecordID,
    getTCards_ScreenDropdown,
    getTCards_TCards_GetJobDetails,
    postTcardsAddUpdate,
    TCards_GetExistingTCardsByRegNumber,
    TCards_SerachJobs
} from '../../../Core/Service/checkInRole'; //...
import { DatePicker, DateTimePicker, PrimaryButton, SelectBox, TextBox } from '../../../Core/FormInput';
import { CustomeSignPad } from '../../../Core/SignaturePad';
import { makeStyles, withStyles } from '@material-ui/styles';
import DialogComp from '../../../Core/Modal/dialogModal';
import AddBoxIcon from '@material-ui/icons/AddBox';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AppContext from '../../../App/AppContext';
import { CustomIconButton } from '../../../Core/FormInput/AppButton';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import formatters from '../../../Core/Grid/inputFormatter';
import moment from 'moment';
import ExistingCardsList from './ExistingCardsList';
import ConfirmationModal from '../../../Core/Controls/Dialog/ConfirmationModal';
import SearchTcardByReg from '../../internal/T-card/searchTcardByReg';

import { useHistory } from 'react-router-dom';
import { set } from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 15
    },
    inputBase: {
        '&.MuiFormControl-fullWidth': {
            // background: 'white'
            // border: '1px solid rgba(0, 0, 0, 0.3)'
        },
        '& .MuiOutlinedInput-inputMarginDense': {
            padding: '13px',
            border: 'none',
            background: 'white',
            borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
        },
        '.MuiInputBase-root': {
            background: 'white',
            borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
        }
    },
    table: {
        minWidth: 1250
    },
    title: {
        color: '#f50057',
        marginLeft: 8,
        marginTop: 8,
        marginBottom: 8
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        border: '1px solid rgba(0,0,0,0.2)'
    },
    axelTitles: {
        textAlign: 'center',
        color: '#f50057',
        width: '100%'
    },
    headings: {
        color: '#f50057',
        margin: 0,
        marginLeft: -4,
        marginBottom: 20
    }
}));
const StyledTableRow = withStyles((theme) => ({
    root: {
        // '&:hover': {
        //     backgroundColor: 'grey',
        //     color: 'white'
        // },
        cursor: 'pointer'
    }
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
    head: {
        // padding: ' 5px',
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82',
        padding: '6px 0px 6px 8px'
    },
    body: {
        fontSize: 14,
        // padding: ' 5px'
        // fontSize: 11,
        padding: '6px 0px 6px 8px'
    }
}))(TableCell);

let eventTypeConfig = {
    1: 'Service',
    2: 'MOT',
    3: 'Inspection',
    4: 'Repair',
    5: 'Test',
    6: 'Tacho'
};

const TCardModal = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const branchIDParam = urlParams.get('branchID');
    const { showToast, showModal, portalSettings } = useContext(AppContext);
    const [selectedIndex, setSelectedInedx] = useState(null);
    const [existingTCards, setExistingTCards] = useState([]);
    const [headerDueDate, setHeaderDueDate] = useState('');
    const [btnLoader, setBtnLoader] = useState(false);
    const [showExistingCardsDialog, setShowExistingCardsDialog] = useState(false);
    const classes = useStyles();

    const [formData, setFormData] = useState({
        tCardsID: '',
        tCardsCustomerID: '',

        tCardsBranchID: '',
        tCardsVehicleID: '',
        tCardsRegistrationNumber: '',
        tCardsBookingDate: '',
        tCardsMOTLocation: '',
        tCardsMOTDate: '',
        tCardsLoanVehicle: false,
        tCardIsBreakdown: false,
        tCardsIsCollectionDeliver: false,
        tCardsIsCustomerWaiting: false,
        tCardsStatusID: null,
        tCardsContactNumber: '',
        tCardsContactName: '',
        tCardsServiceAdvisorSignature: '',
        tCardsPaymentTypeID: '',
        tCardsPriorityID: '',
        tCardsMileage: '',
        tCardsCustomerAddress: '',
        tCardsHeaderRecordID: '',
        tCardsDeadlineDate: '',
        tCardsCustomerOrderNumber: '',
        tCardsCustomerSignature: '',
        tCardsCustomerName: '',
        tCardsAgentSignature: '',
        tCardsAgentName: '',
        tCardsIsService: false,
        tCardsIsRecallJob: false,
        tCardsIsMOT: false,
        tCardsIsTacho: false,
        tCardsIsInspection: false,
        tCardsIsRepair: false,
        tCardsIsNightShift: false,
        tCardsCustomerPrintName: '',
        errors: {},
        customers: [],
        branches: [],
        payments: [],
        tCardLineStatus: [],
        tCardsEvents: [],
        tCardsStatus: [],
        tCardsTempEvents: [],
        TCardLineItems: [],
        customersContactList: [],
        tCardPrioritiesList: [],
        isRepair: false,
        errors: {},
        selectedExistingTcardID: null,
        selectedExistingTcard: null,
        tCardsMake: '',
        tCardsModel: '',
        tCardUnitRegNumber: '',
        tCardsIsBrakeTest: false
    });

    const [loader, setLoader] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (formData.TCardLineItems.length > 0) {
            setHeaderDueDate(formData.TCardLineItems[0]?.tCardsLineItemsDueDate || '');
        }
    }, [formData.TCardLineItems]);

    // console.log(props.selectedVehicle.orderNumberRequired);
    const handleHeaderDueDateChange = (e) => {
        const { value } = e.target;
        setHeaderDueDate(value);

        if (formData.TCardLineItems.length > 0) {
            const updatedLineItems = [...formData.TCardLineItems];
            updatedLineItems[0].tCardsLineItemsDueDate = value;
            setFormData((prev) => ({
                ...prev,
                TCardLineItems: updatedLineItems
            }));
        }
    };

    useEffect(async () => {
        let res = await getTCards_ScreenDropdown(); //...
        setFormData((st) => ({
            ...st,
            customers: res.data.customer || [],
            branches: res.data.branches || [],
            payments: res.data.payment || [],
            tCardLineStatus: res.data.tCardLineStatus || [],
            tCardsEvents: res.data.tCardsEvent || [],
            tCardsStatus: res.data.tCardsStatus || [],
            tCardPrioritiesList: res.data.tCardPriorities || []
        }));

        if (props.selectedVehicle?.vehicleID) {
            setFormData((st) => ({
                ...st,
                tCardsCustomerID: props.selectedVehicle.customerID || '',
                tCardsCustomerName: props.selectedVehicle.customer || '',
                tCardsBranchID: props.selectedVehicle.branchID || '',
                tCardsVehicleID: props.selectedVehicle.vehicleID || '',
                tCardsRegistrationNumber: props.selectedVehicle.reg || '',
                tCardsStatusID: null
            }));
        }

        if (props.headerRecordID) {
            if (props.fromWorkFlowDashboard) {
                let res2 = await getTCards_TCards_GetJobDetails(props.headerRecordID);
                setFormData((st) => ({
                    ...st,
                    tCardsCustomerID: res2.data.details[0]?.customerID || '',
                    tCardsCustomerName: res2.data.details[0]?.cust || '',
                    tCardsBranchID: res2.data.details[0]?.branchID || '',
                    tCardsVehicleID: res2.data.details[0]?.vehicleID || '',
                    tCardsRegistrationNumber: res2.data.details[0]?.regNo || '',
                    tCardsBookingDate: formatters.DateFormatter(res2.data.details[0]?.bd) || '',
                    tCardsStatusID: null,
                    tCardsIsRepair: true,
                    // tCardsIsRecallJob: true,
                    TCardLineItems: [
                        {
                            tCardsLineItemsID: null,
                            // tCardsLineItemsPartReqID: x.partReqID,
                            tCardsLineItemstCardsID: '', /// need to check //...
                            tCardsLineItemsDescription: res2.data.details[0]?.jobDescription, //`${x.pd} (${x.pn})`,
                            tCardsLineItemsEventTypeID: 4, /// need to check
                            tCardsLineItemsAllocatedHours: 0,
                            tCardsLineItemsSpentHours: 0,
                            tCardsLineItemsLineStatusID: '',
                            eventName: 'Repair'
                        }
                    ]
                }));
            } else {
                let res = await getTCards_GetPartReqsByHeaderRecordID(props.headerRecordID);
                setFormData((st) => ({
                    ...st,
                    tCardsCustomerID: res.data.partReqs[0]?.customerID || '',
                    tCardsCustomerName: res.data.partReqs[0]?.cust || '',
                    tCardsBranchID: res.data.partReqs[0]?.branchID || '',
                    tCardsVehicleID: res.data.partReqs[0]?.vehicleID || '',
                    tCardsRegistrationNumber: res.data.partReqs[0]?.regNo || '',
                    tCardsStatusID: null,
                    tCardsIsRepair: true,
                    tCardsIsRecallJob: true,
                    TCardLineItems: res.data.partReqs.map((x) => {
                        return {
                            tCardsLineItemsID: null,
                            tCardsLineItemsPartReqID: x.partReqID,
                            tCardsLineItemstCardsID: '', /// need to check //...
                            tCardsLineItemsDescription: `${x.pd} (${x.pn})`,
                            tCardsLineItemsEventTypeID: 4, /// need to check
                            tCardsLineItemsAllocatedHours: 0,
                            tCardsLineItemsSpentHours: 0,
                            tCardsLineItemsLineStatusID: '',
                            eventName: 'Repair'
                        };
                    })
                }));
            }
        }

        if (props.scheduleList?.length > 0) {
            let isEvent = {};
            props.scheduleList.forEach((element) => {
                isEvent[`tCardsIs${eventTypeConfig[element.et]}`] = true;
            });
            // console.log('props.scheduleList', props.scheduleList);
            setFormData((st) => ({
                ...st,
                ...isEvent,
                tCardsCustomerID: props.scheduleList[0].customerID || '',
                tCardsCustomerName: props.scheduleList[0].customer || '',
                tCardsBranchID: props.scheduleList[0].branchID || '',
                tCardsVehicleID: props.scheduleList[0].vehicleID || '',
                tCardsRegistrationNumber: props.scheduleList[0].regNo || '',
                tCardsStatusID: null,
                TCardLineItems: props.scheduleList.map((x) => {
                    return {
                        tCardsLineItemsID: null,
                        tCardsLineItemstCardsID: '', /// need to check //...
                        tCardsLineItemsDescription: x.event,
                        tCardsLineItemsEventTypeID: x.et, /// need to check
                        tCardsLineItemsAllocatedHours: 0,
                        tCardsLineItemsSpentHours: 0,
                        tCardsLineItemsLineStatusID: '',
                        tCardsLineItemsDueDate: x.dueDate ? formatters.DateFormatter(x.dueDate) : '',
                        tCardsLineItemsTMV_ID: x.tmV_ID,
                        eventName: eventTypeConfig[x.et]
                    };
                })
            }));
        }
        if (branchIDParam) {
            setFormData((st) => ({
                ...st,

                tCardsBranchID: branchIDParam || '',

                tCardsStatusID: null
            }));
        }
    }, []);

    useEffect(async () => {
        if (formData.showExistingCardsDialog) {
            // let res = await TCards_SerachJobs(formData.tCardsRegistrationNumber, formData.tCardsBranchID);
            let res = await TCards_GetExistingTCardsByRegNumber(formData.tCardsRegistrationNumber.trim().toUpperCase(), formData.tCardsBranchID);
            setExistingTCards(res.data.tCards.map((q) => ({ ...q, isSelected: false })) || []);
            // if (res.data.jobs.length > 0) {
            //     setShowExistingCardsDialog(true);
            // }
        }
    }, [formData.showExistingCardsDialog]);
    // useEffect(async () => {
    //     if (formData.tCardsVehicleID) {
    //         let res = await getTCards_GetExistingTCards(formData.tCardsVehicleID);
    //         setExistingTCards(res.data.tCards.map((q) => ({ ...q, isSelected: false })) || []);
    //         if (res.data.tCards.length > 0) {
    //             setShowExistingCardsDialog(true);
    //         }
    //     }
    // }, [formData.tCardsVehicleID]);

    const pullDataByCustomerId = async () => {
        if (props.selectedVehicle.customerID) {
            let res = await getTCards_GetCustomerContacts(props.selectedVehicle.customerID); //...
            if (res.data.customerContact.length > 0) {
                setFormData((prev) => ({ ...prev, showCustomerPopup: true, customersContactList: res.data.customerContact || [] }));
            } else {
                showToast('No contact found for this customer.');
            }
        }
    };

    const handleAddToSelectedTCard = () => {
        setShowExistingCardsDialog(true);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prev) => {
            const updatedValue = type === 'checkbox' ? checked : value;
            const newState = { ...prev, [name]: updatedValue };

            if (name === 'tCardsIsRecallJob' && checked) {
                newState.tCardsStatusID = 15;
            }
            if (name === 'tCardsIsRepair' && checked) {
                newState.showJobPopup = true;
                newState.isRepair = true;
            }

            return newState;
        });
    };

    const handleItemCheckChange = (e) => {
        const { name, value, type, checked } = e.target;

        const motRelatedField = 'tCardsIsMOT';
        const inspectionRelatedField = 'tCardsIsInspection';
        const tachoRelatedField = 'tCardsIsTacho';
        const brakeTestRelatedField = 'tCardsIsBrakeTest';
        const serviceRelatedField = 'tCardsIsService';

        let tempEvents = [];

        if (checked) {
            if (name === brakeTestRelatedField) {
                tempEvents = formData.tCardsEvents.filter((x) => x.eventName === 'Brake Test');
            } else if (name === tachoRelatedField) {
                tempEvents = formData.tCardsEvents.filter((x) => x.eventName === 'Tacho');
            } else if (name === serviceRelatedField) {
                tempEvents = formData.tCardsEvents.filter((x) => x.eventName === 'Service');
            } else if (name === motRelatedField) {
                tempEvents = formData.tCardsEvents.filter((x) => x.eventName === 'MOT');
            } else if (name === inspectionRelatedField) {
                tempEvents = formData.tCardsEvents.filter((x) => x.eventName === 'Inspection');
            }
        }

        setFormData((prev) => ({
            ...prev,
            tCardsTempEvents: tempEvents,
            [name]: type === 'checkbox' ? checked : value,
            showJobPopup: checked && tempEvents.length > 0
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        let errorMessages = [];

        if (!formData.tCardsCustomerName) {
            formIsValid = false;
            errors['tCardsCustomerName'] = 'This field is required';
            errorMessages.push('Customer is required');
        }
        if (!formData.tCardsRegistrationNumber) {
            formIsValid = false;
            errors['tCardsRegistrationNumber'] = 'This field is required';
            errorMessages.push('Registration Number is required');
        }
        if (!formData.tCardsBranchID) {
            formIsValid = false;
            errors['tCardsBranchID'] = 'This field is required';
            errorMessages.push('Branch is required');
        }
        if (props.selectedVehicle?.orderNumberRequired) {
            formIsValid = false;
            errors['tCardsCustomerOrderNumber'] = 'This field is required';
            errorMessages.push('Customer Order Number is required');
        }
        if (!formData.tCardsRegistrationNumber) {
            formIsValid = false;
            errors['tCardsRegistrationNumber'] = 'Please enter registration number';
            errorMessages.push('Please enter registration number');
        }
        if (formData.TCardLineItems.length === 0) {
            formIsValid = false;
            errorMessages.push('Please select at least one event.');
            // showToast('Please select at least one event.');
        }
        if (!formData.tCardsPaymentTypeID) {
            formIsValid = false;
            errors['tCardsPaymentTypeID'] = 'This field is required';
            errorMessages.push('Payment Type is required');
            // showToast('Please select at least one event.');
        }
        if (formData.tCardsPaymentTypeID == 1) {
            if (!formData.tCardsCustomerAddress) {
                errors.tCardsCustomerAddress = 'This field is required';
                formIsValid = false;
                errorMessages.push('Please enter customer address');
            }
            if (!formData.tCardsContactNumber) {
                errors.tCardsContactNumber = 'This field is required';
                formIsValid = false;
                errorMessages.push('Please enter contact number');
            }
            if (!formData.tCardsContactName) {
                errors.tCardsContactName = 'This field is required';
                formIsValid = false;
                errorMessages.push('Please enter contact name');
            }
        }
        if (formData.tCardsIsMOT && (formData.tCardsMOTLocation == null || formData.tCardsMOTLocation == '')) {
            errors.tCardsMOTLocation = 'MOT Location is required';
            formIsValid = false;
            errorMessages.push('Please enter MOT Location');
        }
        if (formData.tCardsIsMOT && (formData.tCardsMOTDate == null || formData.tCardsMOTDate == '')) {
            errors.tCardsMOTDate = 'MOT Date is required';
            formIsValid = false;
            errorMessages.push('Please enter MOT Date');
        }
        if (formData.tCardsStatusID == null || formData.tCardsStatusID === '') {
            errors.tCardsStatusID = 'Status is required';
            formIsValid = false;
            errorMessages.push('Please set the Status');
        }

        if (!formData.tCardsStatusID == 0 && (formData.tCardsBookingDate == null || formData.tCardsBookingDate == '')) {
            errors.tCardsBookingDate = 'Booking Date is required';
            formIsValid = false;
            errorMessages.push('Please enter Booking Date');
        }
        setFormData((st) => ({
            ...st,
            errors: errors
        }));

        if (errorMessages.length > 0) {
            showToast(errorMessages.join('\n'));
        }

        return formIsValid;
    };

    const handleSubmit = async (linkToExisting = false) => {
        setLoader(true);
        try {
            if (linkToExisting) {
                if (formData.TCardLineItems.length === 0) {
                    showToast(`Please select at least one event.`);
                    return;
                }
                if (!formData.selectedExistingTcardID) {
                    showToast('Please select a T-Card to add items to');
                    return;
                }
            } else {
                if (!handleValidation()) {
                    return;
                }
            }

            await submitAPIcall();
        } finally {
            setLoader(false);
        }
    };

    const submitAPIcall = async () => {
        const data = {
            tCardsID: formData.tCardsID,
            tCardsBranchID: formData.tCardsBranchID,
            tCardsCustomerID: formData.tCardsCustomerID,
            tCardsVehicleID: formData.tCardsVehicleID,
            tCardsBookingDate: formData.tCardsBookingDate,
            tCardsMOTLocation: formData.tCardsMOTLocation,
            tCardsMOTDate: formData.tCardsMOTDate,
            tCardsLoanVehicle: formData.tCardsLoanVehicle,
            tCardIsBreakdown: formData.tCardIsBreakdown,
            tCardsIsCollectionDeliver: formData.tCardsIsCollectionDeliver,
            tCardsIsCustomerWaiting: formData.tCardsIsCustomerWaiting,
            tCardsStatusID: formData.tCardsStatusID,
            tCardsContactNumber: formData.tCardsContactNumber,
            tCardsContactName: formData.tCardsContactName,
            tCardsServiceAdvisorSignature: formData.tCardsServiceAdvisorSignature,
            tCardsPaymentTypeID: formData.tCardsPaymentTypeID,
            tCardsPriorityID: formData.tCardsPriorityID,
            tCardsMileage: formData.tCardsMileage,
            // tCardsHeaderRecordID: formData.tCardsHeaderRecordID,
            tCardsDeadlineDate: formData.tCardsDeadlineDate,
            tCardsCustomerOrderNumber: formData.tCardsCustomerOrderNumber,
            tCardsCustomerSignature: formData.tCardsCustomerSignature,
            tCardsCustomerName: formData.tCardsCustomerName,
            tCardsAgentSignature: formData.tCardsAgentSignature,
            tCardsAgentName: formData.tCardsAgentName,
            tCardsIsService: formData.tCardsIsService,
            tCardsIsMOT: formData.tCardsIsMOT,
            tCardsIsTacho: formData.tCardsIsTacho,
            tCardsIsRecallJob: formData.tCardsIsRecallJob,
            tCardsIsNightShift: formData.tCardsIsNightShift,
            tCardsIsInspection: formData.tCardsIsInspection,
            tCardsIsRepair: formData.tCardsIsRepair,
            tCardsCustomerPrintName: formData.tCardsCustomerPrintName,
            tCardsRegistrationNumber: formData.tCardsRegistrationNumber,
            TCardLineItems: formData.TCardLineItems || [],
            // TCardsHeaderRecordID: props.headerRecordID,
            TCardsInsertTCardsID: formData.selectedExistingTcardID,
            tCardsDueDate: headerDueDate,
            tCardsCustomerAddress: formData.tCardsCustomerAddress,
            tCardsMake: formData.tCardsMake,
            tCardsModel: formData.tCardsModel,
            tCardUnitRegNumber: formData.tCardUnitRegNumber,
            tCardsIsBrakeTest: formData.tCardsIsBrakeTest
        };
        setBtnLoader(true);

        if (props.fromPage !== 'PartReq') {
            data.TCardsHeaderRecordID = props.headerRecordID || formData.tCardsHeaderRecordID;
        }

        try {
            const res = await postTcardsAddUpdate(data);
            if (res?.success) {
                showToast(res.data.message);
                props.onClose ? props.onClose(true) : history.push('/t_card/dashboard');
            } else if (res?.errors) {
                Object.entries(res.errors).forEach(([key, value]) => {
                    showToast(`${key}: ${value}`);
                });
            } else {
                showToast(res?.message || 'Unexpected error');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            showToast('An error occurred while submitting the form.');
        } finally {
            setBtnLoader(false);
        }
    };

    const handleLineEventValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (formData.isRepair) {
            if (!formData.selectedLineEventDesc) {
                formIsValid = false;
                errors['selectedLineEventDesc'] = 'Please enter description.';
            }
            if (!formData.selectedLineEventAllHrs) {
                formIsValid = false;
                errors['selectedLineEventAllHrs'] = 'Please enter allocated hours.';
            }
        } else {
            if (!formData.selectedLineEvent) {
                formIsValid = false;
                errors['selectedLineEvent'] = 'Please select event.';
            }
        }

        setFormData((st) => ({
            ...st,
            errors: errors
        }));
        return formIsValid;
    };

    const handleRegDetails = (val, motObj) => {
        if (val) {
            setFormData((st) => ({
                ...st,
                tCardsCustomerID: val.customerID,
                // tCardsBranchID: val.branchID,
                tCardsCustomerName: val.customer,
                tCardsRegistrationNumber: val.reg,
                tCardsVehicleID: val.vehicleID,
                showExistingCardsDialog: new Date(),
                // tCardsModel: motObj.model,
                // tCardUnitRegNumber : motObj.model,
                tCardsMake: motObj.make
            }));
        }
    };

    const getRegValue = (val) => {
        if (val) {
            setFormData((st) => ({
                ...st,

                tCardsRegistrationNumber: val
            }));
        }
    };

    const handleLineEventSubmit = () => {
        if (handleLineEventValidation()) {
            if (formData.isRepair) {
                let tempList = [
                    ...formData.TCardLineItems,
                    {
                        tCardsLineItemsID: null,
                        tCardsLineItemstCardsID: '', /// need to check //...
                        tCardsLineItemsDescription: formData.selectedLineEventDesc,
                        tCardsLineItemsEventTypeID: 4, /// need to check
                        tCardsLineItemsAllocatedHours: formData.selectedLineEventAllHrs,
                        tCardsLineItemsSpentHours: 0,
                        tCardsLineItemsLineStatusID: '',
                        tCardsLineItemsDueDate: '',
                        tCardsLineItemsTMV_ID: '',
                        eventName: 'Repair'
                    }
                ];
                setFormData((prev) => ({
                    ...prev,
                    TCardLineItems: tempList,
                    showJobPopup: false,
                    selectedLineEventDesc: '',
                    selectedLineEventAllHrs: '',
                    selectedLineEvent: '',
                    isRepair: false
                }));
            } else {
                let temp = formData.tCardsTempEvents.find((x) => {
                    return x.id == formData.selectedLineEvent;
                });

                let tempList = [
                    ...formData.TCardLineItems,
                    {
                        tCardsLineItemsID: null,
                        tCardsLineItemstCardsID: '', /// need to check //...
                        tCardsLineItemsDescription: temp.name,
                        tCardsLineItemsEventTypeID: temp.tCardEventTypeID,
                        tCardsLineItemsAllocatedHours: temp.allocatedHours,
                        tCardsLineItemsSpentHours: 0,
                        tCardsLineItemsLineStatusID: '',
                        tCardsLineItemsDueDate: formData.selectedLineEventDueDate || '',
                        tCardsLineItemsTMV_ID: '',
                        eventName: temp.eventName,
                        tCardsLineItemsPartReqID: temp.tCardsLineItemsPartReqID
                    }
                ];
                setFormData((prev) => ({
                    ...prev,
                    TCardLineItems: tempList,
                    showJobPopup: false,
                    selectedLineEventDesc: '',
                    selectedLineEventAllHrs: '',
                    selectedLineEvent: '',
                    selectedLineEventDueDate: '',
                    isRepair: false,
                    tCardsMOTDate: formData.tCardsIsMOT && !formData.tCardsMOTDate ? formData.selectedLineEventDueDate : formData.tCardsMOTDate
                }));
            }
        }
    };

    const handleLineEventChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectedLineEventStatusChange = (e, index) => {
        const { name, value, type, checked } = e.target;
        let tempList = [...formData.TCardLineItems];
        tempList[index][name] = value;
        setFormData((prev) => ({ ...prev, TCardLineItems: tempList }));
    };

    const addRepairLine = () => {
        setFormData((prev) => ({ ...prev, showJobPopup: true, isRepair: true }));
    };

    const removeRepairLine = (index) => {
        let tempList = [...formData.TCardLineItems];
        tempList.splice(index, 1);
        setFormData((prev) => ({ ...prev, TCardLineItems: tempList }));
    };

    const selectCustContact = (name, tel) => {
        setFormData((prev) => ({ ...prev, tCardsContactName: name, tCardsContactNumber: tel, showCustomerPopup: false }));
    };

    const closeWarningModal = (res) => {
        setFormData((st) => {
            let newSt = { ...st };
            newSt.showJobPopup = false;
            newSt.isRepair = false;
            newSt.showCustomerPopup = false;

            return newSt;
        });
    };

    const editRowSelect = (index) => {
        setSelectedInedx(index);
    };

    const modalTitleRender = () => {
        return 'Add T-card';
    };

    const handleButtonStatusClick = (statusKey, id) => {
        setFormData((prevState) => ({
            ...prevState,
            [statusKey]: id
        }));
    };

    const onJobSelect = (checked, tCardsID) => {
        let temp = [...existingTCards];
        let job = temp.find((d) => d.tCardsID === tCardsID);
        if (job) {
            temp.forEach((d) => (d.isSelected = false));
            job.isSelected = checked;
            temp = [...temp];
        }
        setFormData((prevState) => ({
            ...prevState,
            selectedExistingTcardID: checked ? tCardsID : undefined,
            selectedExistingTcard: checked ? job : null
        }));
        setExistingTCards(temp);
    };

    const confirmationModalClose = () => {
        setFormData((st) => ({ ...st, showConfirmModal: false }));
    };
    const confirmationModalOpen = () => {
        setFormData((st) => ({ ...st, showConfirmModal: true }));
    };

    return (
        // <DialogComp title={modalTitleRender()} maxWidth="xl" onClose={() => props.onClose(false)} fullWidth overflow="auto" fullScreen>
        <div style={{ padding: 10, background: 'white' }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6} md={6} lg>
                            <SearchTcardByReg
                                getRegValues={handleRegDetails}
                                value={formData.tCardsRegistrationNumber}
                                getReg={getRegValue}
                                isError={true}
                                inputProps={{ style: { textTransform: 'uppercase' } }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                            <FormLabel component="legend" style={{ marginBottom: '3px' }} error>
                                Customer
                            </FormLabel>
                            <TextBox fullWidth name="tCardsCustomerName" value={formData.tCardsCustomerName} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={1}>
                            {' '}
                            <FormLabel component="legend" style={{ marginBottom: '7px' }} error required>
                                Payment Type
                            </FormLabel>
                            <SelectBox
                                fullWidth
                                name="tCardsPaymentTypeID"
                                value={formData.tCardsPaymentTypeID}
                                onChange={handleChange}
                                List={formData.payments || []}
                            />
                            <FormHelperText error>{formData.errors['tCardsPaymentTypeID']}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2}>
                            <InputLabel>Make</InputLabel>
                            <TextBox name="tCardsMake" value={formData.tCardsMake} onChange={handleChange} />
                        </Grid>
                        {/* <Grid item xs={12} sm={4} md={4} lg>
                            <InputLabel shrink>Model</InputLabel>
                            <TextBox name="tCardsModel" value={formData.tCardsModel} onChange={handleChange} />
                        </Grid> */}
                        <Grid item xs={12} sm={4} md={4} lg={1}>
                            <InputLabel>Unit Reg Number</InputLabel>
                            <TextBox name="tCardUnitRegNumber" value={formData.tCardUnitRegNumber} onChange={handleChange} />
                        </Grid>

                        {existingTCards.length > 0 ? (
                            <Grid item xs={12} sm={4} md={4} lg={2}>
                                <PrimaryButton fullWidth onClick={() => setShowExistingCardsDialog(true)} isBtnLoader={btnLoader} style={{ marginTop: 20 }}>
                                    Create/Add to Existing T-Card
                                </PrimaryButton>
                            </Grid>
                        ) : (
                            <Grid item xs={12} sm={4} md={4} lg>
                                {' '}
                                <PrimaryButton fullWidth onClick={() => handleSubmit()} isBtnLoader={btnLoader} style={{ marginTop: 20 }}>
                                    Create TCard
                                </PrimaryButton>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={4} md={4} lg={1}>
                            {' '}
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                onClick={() => (props.onClose ? props.onClose() : history.goBack())}
                                style={{ marginTop: 20 }}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        {formData.tCardsPaymentTypeID == 1 && (
                            <Grid item xs={12}>
                                <InputLabel error required>
                                    Customer Address
                                </InputLabel>
                                <TextBox name="tCardsCustomerAddress" value={formData.tCardsCustomerAddress} onChange={handleChange} />
                                <FormHelperText error>{formData.errors['tCardsCustomerAddress']}</FormHelperText>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Grid container justifyContent="flex-start">
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsService" checked={formData.tCardsIsService} onChange={handleItemCheckChange} />}
                                        label="Service"
                                    />
                                </Grid>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsMOT" checked={formData.tCardsIsMOT} onChange={handleItemCheckChange} />}
                                        label="MOT"
                                    />
                                </Grid>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsInspection" checked={formData.tCardsIsInspection} onChange={handleItemCheckChange} />}
                                        label="Inspection"
                                    />
                                </Grid>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsRepair" checked={formData.tCardsIsRepair} onChange={handleChange} />}
                                        label="Repair"
                                    />
                                </Grid>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsBrakeTest" checked={formData.tCardsIsBrakeTest} onChange={handleItemCheckChange} />}
                                        label="Break Test"
                                    />
                                </Grid>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsTacho" checked={formData.tCardsIsTacho} onChange={handleItemCheckChange} />}
                                        label="Tacho"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} xl={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsRecallJob" checked={formData.tCardsIsRecallJob} onChange={handleChange} />}
                                        label="Recall"
                                    />
                                </Grid>

                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsLoanVehicle" checked={formData.tCardsLoanVehicle} onChange={handleChange} />}
                                        label="Loan Vehicle"
                                    />
                                </Grid>
                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardIsBreakdown" checked={formData.tCardIsBreakdown} onChange={handleChange} />}
                                        label="Breakdown"
                                    />
                                </Grid>

                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox name="tCardsIsCollectionDeliver" checked={formData.tCardsIsCollectionDeliver} onChange={handleChange} />
                                        }
                                        label="Collection/Deliver"
                                    />
                                </Grid>

                                <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} style={{ textAlign: 'left' }}>
                                    <FormControlLabel
                                        control={<Checkbox name="tCardsIsCustomerWaiting" checked={formData.tCardsIsCustomerWaiting} onChange={handleChange} />}
                                        label="Customer Waiting"
                                    />
                                </Grid>
                                {!props.hideIsNightShiftFlag && (
                                    <Grid item xs={'auto'} sm={6} md={'auto'} lg={2} style={{ textAlign: 'left' }}>
                                        <FormControlLabel
                                            control={<Checkbox name="tCardsIsNightShift" checked={formData.tCardsIsNightShift} onChange={handleChange} />}
                                            label="Is Night Shift?"
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend" style={{ marginBottom: '3px' }} error>
                                Branch
                            </FormLabel>
                            <SelectBox onChange={handleChange} value={formData.tCardsBranchID} name="tCardsBranchID" List={formData.branches || []} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend" className={!formData.tCardsStatusID == 0 ? 'mandatoryfields' : ''}>
                                Booking Date
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsBookingDate"
                                type="date"
                                value={formData.tCardsBookingDate}
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                            />
                            {!formData.tCardsStatusID == 0 && <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsBookingDate']}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            {' '}
                            <FormLabel component="legend">Deadline Date</FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsDeadlineDate"
                                type="datetime-local"
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                                value={formData.tCardsDeadlineDate}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend">Due Date</FormLabel>
                            <TextBox
                                fullWidth
                                name="headerDueDate"
                                type="datetime-local"
                                value={headerDueDate}
                                onChange={handleHeaderDueDateChange}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend" className={props.selectedVehicle?.orderNumberRequired ? 'mandatoryfields' : ''}>
                                Customer Order Number
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsCustomerOrderNumber"
                                value={formData.tCardsCustomerOrderNumber}
                                onChange={handleChange}
                                error={!!formData.errors.tCardsCustomerOrderNumber}
                            />
                            {formData.errors.tCardsCustomerOrderNumber && (
                                <FormHelperText style={{ color: 'red' }}>{formData.errors.tCardsCustomerOrderNumber}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            {' '}
                            <FormLabel component="legend" error={formData.tCardsPaymentTypeID == 1} required={formData.tCardsPaymentTypeID == 1}>
                                Contact Name
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsContactName"
                                value={formData.tCardsContactName}
                                onChange={handleChange}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CustomIconButton toolTipTitle="Get Vehicle Details" onClick={pullDataByCustomerId}>
                                                <SearchIcon />
                                            </CustomIconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <FormHelperText error>{formData.errors['tCardsContactName']}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            {' '}
                            <FormLabel component="legend" error={formData.tCardsPaymentTypeID == 1} required={formData.tCardsPaymentTypeID == 1}>
                                Contact Number
                            </FormLabel>
                            <TextBox fullWidth name="tCardsContactNumber" value={formData.tCardsContactNumber} onChange={handleChange} />
                            <FormHelperText error>{formData.errors['tCardsContactNumber']}</FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            {' '}
                            <FormLabel component="legend">Mileage</FormLabel>
                            <TextBox fullWidth name="tCardsMileage" value={formData.tCardsMileage} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend" required={formData.tCardsIsMOT} className={formData.tCardsIsMOT ? 'mandatoryfields' : ''}>
                                MOT Location
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsMOTLocation"
                                value={formData.tCardsMOTLocation}
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                            />
                            {formData.tCardsIsMOT && <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsMOTLocation']}</FormHelperText>}{' '}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend" required={formData.tCardsIsMOT} className={formData.tCardsIsMOT ? 'mandatoryfields' : ''}>
                                MOT Date
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsMOTDate"
                                type="datetime-local"
                                value={formData.tCardsMOTDate}
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                            />
                            {formData.tCardsIsMOT && <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsMOTDate']}</FormHelperText>}{' '}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend">Priority</FormLabel>
                            <SelectBox
                                style={{ marginBottom: '4px', marginTop: '8px' }}
                                fullWidth
                                name="tCardsPriorityID"
                                value={formData.tCardsPriorityID}
                                onChange={handleChange}
                                List={formData.tCardPrioritiesList || []}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                                <FormLabel shrink required style={{ marginBottom: '10px', color: 'red' }}>
                                    Status
                                </FormLabel>
                                <SelectBox onChange={handleChange} value={formData.tCardsStatusID} name="tCardsStatusID" List={formData.tCardsStatus || []} />
                                <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsStatusID']}</FormHelperText>
                            </Grid> */}
                        <Grid item xs={12} sm={12} md={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <InputLabel className="mandatoryfields" required>
                                        Status
                                    </InputLabel>
                                </Grid>
                                <Grid item xs={12}>
                                    <ButtonGroup color="secondary" aria-label="outlined secondary button group" fullWidth>
                                        {formData.tCardsStatus.map((item, index) => (
                                            <Button
                                                style={{
                                                    fontSize: 10
                                                    // backgroundColor: formData.tCardsStatusID === item.id ? 'green' : ''
                                                }}
                                                onClick={() => handleButtonStatusClick('tCardsStatusID', item.id)}
                                                key={index}
                                                variant={formData.tCardsStatusID === item.id ? 'contained' : 'outlined'}
                                            >
                                                {item.name}
                                            </Button>
                                        ))}
                                    </ButtonGroup>
                                    <FormHelperText error>{formData.errors['tCardsStatusID']}</FormHelperText>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Grid item xs={12} lg={4}>
                        <ExistingCardsList existingTCards={existingTCards} onJobSelect={onJobSelect} />
                    </Grid> */}
                <Grid item xs={12}>
                    <TableContainer style={{ height: 250, border: '1px solid rgba(0,0,0,0.2)' }}>
                        <Table className={classes.table} size="small" stickyHeader>
                            <TableHead>
                                <TableRow className="header">
                                    <StyledTableCell width="5%">
                                        <AddBoxIcon onClick={addRepairLine} style={{ color: 'green', verticalAlign: 'middle', cursor: 'pointer' }} />
                                    </StyledTableCell>
                                    <StyledTableCell width="8%">Event Type</StyledTableCell>
                                    {/* {!props.headerRecordID && <StyledTableCell width="8%">Due Date</StyledTableCell>} */}
                                    <StyledTableCell width="45%">Description/Comments</StyledTableCell>
                                    <StyledTableCell width="6%">Allocated</StyledTableCell>
                                    <StyledTableCell width="6%">Spent</StyledTableCell>
                                    <StyledTableCell width="25%">Status</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formData.TCardLineItems.map((q, i) => {
                                    return (
                                        // <StyledTableRow>
                                        //     <StyledTableCell>
                                        //         <RemoveCircleIcon onClick={() => removeRepairLine(i)} />
                                        //     </StyledTableCell>
                                        //     <StyledTableCell>{q.eventName}</StyledTableCell>
                                        //     <StyledTableCell>{q.tCardsLineItemsDescription}</StyledTableCell>
                                        //     <StyledTableCell>{q.tCardsLineItemsAllocatedHours}</StyledTableCell>
                                        //     <StyledTableCell>{q.tCardsLineItemsSpentHours}</StyledTableCell>
                                        //     <StyledTableCell>
                                        //         <SelectBox
                                        //             fullWidth
                                        //             name="tCardsLineItemsLineStatusID"
                                        //             value={q.tCardsLineItemsLineStatusID}
                                        //             onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                        //             List={formData.tCardLineStatus || []}
                                        //         />
                                        //     </StyledTableCell>
                                        // </StyledTableRow>

                                        <StyledTableRow key={i}>
                                            <StyledTableCell>
                                                <RemoveCircleIcon
                                                    onClick={() => removeRepairLine(i)}
                                                    fontSize="small"
                                                    style={{ color: 'red', cursor: 'pointer' }}
                                                />
                                                &nbsp; &nbsp;
                                                {selectedIndex === i ? (
                                                    <CheckCircleIcon
                                                        onClick={() => editRowSelect(null)}
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer', color: 'green' }}
                                                    />
                                                ) : (
                                                    <EditIcon
                                                        onClick={() => editRowSelect(i)}
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer', color: '#2964D9' }}
                                                    />
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell>{q.eventName || '-'}</StyledTableCell>
                                            {/* {!props.headerRecordID && (
                                                <StyledTableCell>
                                                    {selectedIndex === i ? (
                                                        <div style={{ marginTop: -4 }}>
                                                            {/* <TextBox
                                                                name="tCardsLineItemsDueDate"
                                                                type="datetime-local"
                                                                onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                                value={q.tCardsLineItemsDueDate}
                                                            /> 
                                                            <DatePicker
                                                                name="tCardsLineItemsDueDate"
                                                                value={q.tCardsLineItemsDueDate}
                                                                onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div>{q.tCardsLineItemsDueDate ? formatters.MonthShortFormatter(q.tCardsLineItemsDueDate) : '-'}</div>
                                                    )}
                                                </StyledTableCell>
                                            )} */}
                                            <StyledTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <TextBox
                                                            name="tCardsLineItemsDescription"
                                                            value={q.tCardsLineItemsDescription}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>{q.tCardsLineItemsDescription || '-'}</div>
                                                )}
                                            </StyledTableCell>

                                            <StyledTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <TextBox
                                                            name="tCardsLineItemsAllocatedHours"
                                                            value={q.tCardsLineItemsAllocatedHours}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div> {q.tCardsLineItemsAllocatedHours || '-'}</div>
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <TextBox
                                                            name="tCardsLineItemsSpentHours"
                                                            value={q.tCardsLineItemsSpentHours}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div> {q.tCardsLineItemsSpentHours}</div>
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <div style={{ marginTop: -5 }}>
                                                    <SelectBox
                                                        fullWidth
                                                        name="tCardsLineItemsLineStatusID"
                                                        value={q.tCardsLineItemsLineStatusID}
                                                        onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        List={formData.tCardLineStatus || []}
                                                    />
                                                </div>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                {/* <Grid item xs={6}>
                    <PrimaryButton fullWidth onClick={() => handleSubmit()} isBtnLoader={btnLoader}>
                        Create TCard
                    </PrimaryButton>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="contained" color="secondary" fullWidth onClick={() => (props.onClose ? props.onClose() : history.goBack())}>
                        Cancel
                    </Button>
                </Grid> */}
                {/* <Grid item xs={6}>
                        <Button variant="contained" color="primary" fullWidth onClick={confirmationModalOpen} disabled={!formData.selectedExistingTcardID}>
                            Add To selected TCard
                        </Button>
                    </Grid> */}
            </Grid>
            {formData.showJobPopup ? (
                <DialogComp
                    title={formData.isRepair ? 'Add Defect' : `Select Event`}
                    maxWidth="sm"
                    onClose={() => closeWarningModal(false)}
                    fullWidth
                    overflow="auto"
                >
                    <Grid container spacing={2} alignItems="flex-end">
                        {formData.isRepair ? (
                            <>
                                <Grid item xs={12}>
                                    <FormLabel component="legend">Description</FormLabel>
                                    <TextBox
                                        fullWidth
                                        name="selectedLineEventDesc"
                                        value={formData.selectedLineEventDesc}
                                        onChange={handleChange}
                                        autoFocus={true}
                                    />
                                    <FormHelperText style={{ color: 'red' }}>{formData.errors['selectedLineEventDesc']}</FormHelperText>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormLabel component="legend">Allocated Hours</FormLabel>
                                    <TextBox fullWidth name="selectedLineEventAllHrs" value={formData.selectedLineEventAllHrs} onChange={handleChange} />
                                    <FormHelperText style={{ color: 'red' }}>{formData.errors['selectedLineEventAllHrs']}</FormHelperText>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    <SelectBox
                                        onChange={handleLineEventChange}
                                        value={formData.selectedLineEvent}
                                        name="selectedLineEvent"
                                        List={formData.tCardsTempEvents || []}
                                    />
                                    <FormHelperText style={{ color: 'red' }}>{formData.errors['selectedLineEvent']}</FormHelperText>
                                </Grid>
                                {/* {!props.headerRecordID && (
                                    <Grid item xs={12}>
                                        <DateTimePicker name="selectedLineEventDueDate" value={formData.selectedLineEventDueDate} onChange={handleChange} />
                                    </Grid>
                                )} */}
                            </>
                        )}
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth onClick={handleLineEventSubmit}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </DialogComp>
            ) : null}
            {formData.showCustomerPopup ? (
                <DialogComp title={`Select Customer Contact`} maxWidth="md" onClose={() => closeWarningModal(false)} fullWidth>
                    <TableContainer style={{ height: 300, border: '1px solid rgba(0,0,0,0.2)' }}>
                        <Table size="small" width="550px" stickyHeader>
                            <TableHead>
                                <TableRow className="header">
                                    <StyledTableCell>Name</StyledTableCell>
                                    <StyledTableCell>Tel 1</StyledTableCell>
                                    <StyledTableCell>Tel 2</StyledTableCell>
                                    <StyledTableCell>Email</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formData.customersContactList.map((q, i) => {
                                    return (
                                        <StyledTableRow>
                                            <StyledTableCell>{q.name}</StyledTableCell>
                                            <StyledTableCell onClick={() => selectCustContact(q.name, q.tel1)} style={{ textDecoration: 'underline' }}>
                                                {q.tel1}
                                            </StyledTableCell>
                                            <StyledTableCell onClick={() => selectCustContact(q.name, q.tel2)} style={{ textDecoration: 'underline' }}>
                                                {q.tel2}
                                            </StyledTableCell>
                                            <StyledTableCell>{q.email}</StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogComp>
            ) : null}

            {formData.showConfirmModal ? (
                <DialogComp title={`Warning`} onClose={confirmationModalClose} maxWidth="sm">
                    <ConfirmationModal
                        message={`Are you sure you want to add T-card items to ${formData.selectedExistingTcard.notes} (${
                            formData.selectedExistingTcard.bd ? formatters.YearFormatter(formData.selectedExistingTcard.bd) : ''
                        })?`}
                        handleSubmit={handleSubmit}
                        handleCancel={confirmationModalClose}
                    />
                </DialogComp>
            ) : null}

            {showExistingCardsDialog && (
                <DialogComp title="Select Existing T-Card" onClose={() => setShowExistingCardsDialog(false)} maxWidth="xl" fullWidth overflow="auto">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <ExistingCardsList existingTCards={existingTCards} onJobSelect={onJobSelect} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => {
                                            if (!formData.selectedExistingTcardID) {
                                                showToast('Please select a T-Card to add items to');
                                                return;
                                            }
                                            setShowExistingCardsDialog(false);
                                            handleSubmit(true);
                                        }}
                                        disabled={!formData.selectedExistingTcardID}
                                    >
                                        Add to Selected T-Card
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        fullWidth
                                        onClick={() => {
                                            const resetTCards = existingTCards.map((t) => ({ ...t, isSelected: false }));
                                            setExistingTCards(resetTCards);
                                            setFormData((prev) => ({ ...prev, selectedExistingTcardID: null }));
                                            handleSubmit(false);
                                        }}
                                    >
                                        Create New T-Card
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogComp>
            )}
        </div>
        //  </DialogComp>
    );
};

export default TCardModal;
